import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { AnimatePresence, motion } from 'motion/react'
import type { ReactNode } from 'react'

export interface FormDialogProps {
	open: boolean
	onClose: () => void
	title: ReactNode
	children: ReactNode
	/** Max width variant. Defaults to `'md'`. */
	maxWidth?: 'md' | 'lg'
}

const maxWidthClass = {
	md: 'max-w-md',
	lg: 'max-w-lg',
} as const

export function FormDialog({ open, onClose, title, children, maxWidth = 'md' }: FormDialogProps) {
	return (
		<AnimatePresence>
			{open && (
				<Dialog static open={open} onClose={onClose} className="relative z-50">
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						className="fixed inset-0 bg-black/20 backdrop-blur-sm"
					/>
					<div className="fixed inset-0 w-screen overflow-y-auto">
						<div className="flex min-h-full items-center justify-center p-4">
							<DialogPanel
								as={motion.div}
								initial={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
								animate={{ opacity: 1, scale: 1, transition: { duration: 0.2 } }}
								exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
								className={`w-full ${
									maxWidthClass[maxWidth]
								} rounded-xl bg-white p-6 shadow-lg ring-1 ring-grey-200/50`}
							>
								<DialogTitle className="text-lg font-medium text-grey-900 mb-4">
									{title}
								</DialogTitle>
								{children}
							</DialogPanel>
						</div>
					</div>
				</Dialog>
			)}
		</AnimatePresence>
	)
}
